// extracted by mini-css-extract-plugin
export var icon = "_49-1";
export var subtext = "_49-0";